import React, { Fragment,useState,useEffect } from 'react'
import { Breadcrumbs } from "@material-tailwind/react";
import { Link } from 'react-router-dom';
import AIcon from './../partials/AIcon'

export default function ABreadcrumbs({links}) {
  return (
    <Breadcrumbs>
    <Link to="/db/dashboard" className="opacity-60">
      <AIcon name="home" /> <span className='capitalize bahijB'>دشــبورد</span>
    </Link>
    {
        links?.map((l, i)=>{
            return( <Fragment key={i}>
            { i<links.length-1? <Link key={i} to={"/db"+l.link}> <span className='capitalize bahijB'>{l.name}</span> </Link>:
             <span className='capitalize amiriB'>{l.name}</span> }
            </Fragment>)
                
        })
    }
  </Breadcrumbs>
  )
}
